<template>
    <div>
        <p>
            <strong>Nombre: </strong>
            <span>{{solicitudObject.razon_o_nombre}}</span>
            <br />
            <strong>Solicitante: </strong>
            <span>{{ solicitudObject.nombre_solicitante }}</span>
            <br />
            <strong>Monto: </strong>
            <span>MX {{ solicitudObject.monto }}</span>
            <br />
            <strong>Estado: </strong>
            <span>{{ solicitudObject.status_description ? solicitudObject.status_description : "-" }}</span>
        </p>
        <hr/>
        
        <p>
            <strong>Campus: </strong>
            <span>{{ solicitudObject.campus ? campus(solicitudObject.campus) : "-" }}</span>
            <br />
            <strong>Departamento: </strong>
            <span>{{ solicitudObject.departamento ? solicitudObject.departamento.nombre : "-" }}</span>
            <br />
            <strong>Concepto: </strong>
            <span>{{ solicitudObject.concepto ? solicitudObject.concepto.nombre : "-" }}</span>
            <br />
            <strong>Fecha de solicitud: </strong>
            <span>{{ solicitudObject.fecha_solicitud }}</span>
            <br />
            <strong>Fecha de pago: </strong>
            <span>{{ solicitudObject.fecha_pago }}</span>
        </p>
        <hr />

        <p>
            <strong>Tipo de monto: </strong>
            <span>{{ solicitudObject.tipo_monto ? solicitudObject.tipo_monto.nombre : "-" }}</span>
            <br />
            <strong>Forma de pago: </strong>
            <span>{{ solicitudObject.forma_pago ? solicitudObject.forma_pago.nombre : "-" }}</span>
            <br />
            <strong>Categoria: </strong>
            <span>{{ solicitudObject.solicitud_pago_categoria !== null ? solicitudObject.solicitud_pago_categoria.categoria : "-" }}</span>
        </p>
        <hr />

        <p>
            <strong>Banco: </strong>
            <span>{{ solicitudObject.banco ? solicitudObject.banco.nombre : "-" }}</span>
            <br />
            <strong>Cuenta: </strong>
            <span>{{  solicitudObject.cuenta ? solicitudObject.cuenta : "-" }}</span>
            <br />
            <strong>Clave: </strong>
            <span>{{  solicitudObject.clave ? solicitudObject.clave : "-"}}</span>
            <br />
            <strong>Factura: </strong>
            <span>{{ solicitudObject.factura_real !== 'null' ? solicitudObject.factura_real : "-" }}</span>
        </p>
        <hr />

        <p>
            <strong>Descripción: </strong>
            <span>{{  solicitudObject.descripcion}}</span>
            <br />
            <strong>Comprobante: </strong>
            <span>{{  solicitudObject.comprobante_real !== 'null' ? solicitudObject.comprobante_real : "-"}}</span>
        </p>
    </div>
</template>

<script>
export default {
    name: "PrintSolicitudPagoTemplate",
    props: {
        solicitudObject: { type: Object, default: null }
    },
    methods: {
        campus (value) {
            let result = ''
            value.forEach(el => result += el.nombre + ', ')
            result = result.slice(0, -2)
            return result
        }
    }
}
</script>

<style scoped></style>
